import type { RawValue } from 'src/components/declare'
import type { EasyRemoteSearch } from 'src/components/common/declare'
import { useState, useMemo, useContext, useEffect } from 'react'
import { Form, Button } from 'antd'
import { DatePicker, EasyRemoteSelect, ModalContext, ListTableContext, postMsg } from 'src/components'
import { mainStore } from 'enasops/stores'
import { $api } from 'src/plugins'
import { initFilter, initGroup, getSingleRule, extendRules, extendGroups } from 'src/utils/common'
import { pick } from 'lodash'

const AuthManage = (props: { record?: any }) => {
  const modal = useContext(ModalContext)
  const table = useContext(ListTableContext)

  const [state, setState] = useState({
    AppId: table.selectedRow.ID,
    TenantCode: '',
    ExpireTime: ''
  })
  useEffect(() => {
    props.record && setState(pick(props.record, ['AppId', 'TenantCode', 'ExpireTime']))
  }, [props.record])

  const getList = (params: EasyRemoteSearch) => {
    const { OrgId } = mainStore.headers
    const payload = initFilter({ OrgId, PageIndex: params.current })
    extendRules(payload, [getSingleRule('FLOW_STATUS', 1, 1)])
    // 搜索过滤字段
    const filterFields: string[] = ['NAME']
    const value = params.value ?? ''
    const Groups: any = initGroup(false)
    String(value) && Groups.Rules.push(...filterFields.map(field => getSingleRule(field, 9, value as RawValue)))
    extendGroups(payload, [Groups])

    return $api['app/getDataByPost'](payload, {
      url: '/OP/Tenant/OrderPaged',
      fullData: true
    })
  }

  const handleOk = () => {
    if (state.TenantCode && state.ExpireTime) {
      const url = `op028/${!!props.record ? 'updateAppExpireTimeByAdmin' : 'installAppByAdmin'}`
      $api[url](state).then(res => {
        if (res) {
          handleCancel()
          postMsg('操作成功')
        } else {
          postMsg('该租户已授权，请选择其他租户', 'error')
        }
      })
    } else {
      postMsg('请检测必填项', 'error')
    }
  }

  const handleCancel = () => {
    modal.close()
  }

  const selectedValue = useMemo(() => {
    if (!state.TenantCode) return
    return {
      label: undefined,
      value: state.TenantCode
    }
  }, [state.TenantCode])
  return (
    <Form layout='vertical'>
      <Form.Item label='租户名称' required>
        <EasyRemoteSelect
          selectProps={{ disabled: !!props.record }}
          remoteMethod={getList}
          fieldOption={{ value: 'CODE' }}
          value={selectedValue}
          onChange={(val: any) => setState(prev => ({ ...prev, TenantCode: val.value }))}
        />
      </Form.Item>
      <Form.Item label='截止时间' required>
        <DatePicker
          value={state.ExpireTime}
          onChange={val => setState(prev => ({ ...prev, ExpireTime: val }))}
          className='full-width'
        />
      </Form.Item>
      <Form.Item className='text-right mg-t24'>
        <Button onClick={handleCancel} className='mg-r8'>取消</Button>
        <Button type='primary' onClick={handleOk}>确认</Button>
      </Form.Item>
    </Form>
  )
}

export default AuthManage